import { render, staticRenderFns } from "./mobileHealthDataAccess.vue?vue&type=template&id=7c99bc55&scoped=true&"
import script from "./mobileHealthDataAccess.vue?vue&type=script&lang=js&"
export * from "./mobileHealthDataAccess.vue?vue&type=script&lang=js&"
import style0 from "./mobileHealthDataAccess.vue?vue&type=style&index=0&id=7c99bc55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c99bc55",
  null
  
)

component.options.__file = "mobileHealthDataAccess.vue"
export default component.exports